import React, { useState } from 'react';
import styled from 'styled-components';
import { Popover as AntPopover } from 'antd';
const Popover = ({ title, getContent, trigger, placement, children, arrowPointAtCenter, className, destroyPopoverOnHide }) => {
    const [isVisible, setIsVisible] = useState(false);
    const onHide = () => setIsVisible(false);
    return (<AntPopover destroyTooltipOnHide={destroyPopoverOnHide} title={title} content={getContent(onHide)} trigger={trigger} placement={placement} arrowPointAtCenter={arrowPointAtCenter} overlayClassName={className} visible={isVisible} onVisibleChange={setIsVisible}>
      {children}
    </AntPopover>);
};
const StyledPopover = styled(Popover) `
  .ant-popover-inner-content {
    padding: 0;
  }
`;
export default StyledPopover;
